import React from 'react';

const styles = {
  loader: {
    padding: '20px',
    textAlign: 'center'
  }
};

const Loader = () => (
  <div style={styles.loader}>
    <p>Loading...</p>
  </div>
);

export default Loader;
